const rankings = [
  { rank: 1, title: "顶流男星私生活连环塌房：时间线全梳理", heat: "9.8万", tag: "爆", tagColor: "bg-primary-500" },
  { rank: 2, title: "头部带货主播翻车实录：假货产业链内幕", heat: "8.5万", tag: "热", tagColor: "bg-accent-500" },
  { rank: 3, title: "某选秀节目投票造假完整证据链曝光", heat: "7.2万", tag: "热", tagColor: "bg-accent-500" },
  { rank: 4, title: "知名女星税务问题再起波澜，细节流出", heat: "6.8万", tag: "新", tagColor: "bg-secondary-500" },
  { rank: 5, title: "综艺导演潜规则爆料：选手被迫签霸王条款", heat: "5.9万", tag: "", tagColor: "" },
  { rank: 6, title: "网红情侣分手互撕：双方黑历史被扒光", heat: "5.4万", tag: "", tagColor: "" },
  { rank: 7, title: "品牌代言虚假宣传被实锤，涉及多位艺人", heat: "4.7万", tag: "新", tagColor: "bg-secondary-500" },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          黑料热度榜
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-4 rounded-full"></div>
        <p className="text-center text-foreground-500 text-xs mb-10">实时更新 · 基于讨论量与传播热度</p>

        <div className="space-y-2">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-50 rounded-lg px-5 py-4 border border-background-200/50 hover:border-primary-500/20 transition-colors group cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                  item.rank === 1
                    ? "bg-primary-500 text-background-50"
                    : item.rank === 2
                    ? "bg-accent-500 text-background-50"
                    : item.rank === 3
                    ? "bg-accent-600 text-background-50"
                    : "bg-background-200 text-foreground-500"
                }`}
              >
                {item.rank}
              </span>
              <span className="flex-1 text-foreground-300 text-sm group-hover:text-foreground-100 transition-colors truncate">
                {item.title}
              </span>
              {item.tag && (
                <span className={`flex-shrink-0 px-2 py-0.5 rounded text-xs font-semibold ${item.tagColor} text-background-50 whitespace-nowrap`}>
                  {item.tag}
                </span>
              )}
              <span className="flex-shrink-0 text-foreground-500 text-xs whitespace-nowrap">
                <i className="ri-fire-line text-accent-500 mr-1"></i>
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}